import { Typography } from "@mui/material";
import React, { useRef } from "react";
import "./noDataComponent.css";

const NoDataComponent = () => {

  return (
    <div className="no-data-root" id="no-data" key="no-data">
      <img
        className="no-data-image"
        src="/assets/analytics/empty-img-simple.svg"
      />
      <div className="no-data-text">
        <Typography className="mainTextFont">No Data</Typography>
        <Typography className="subText">
          Please select a different filter{" "}
        </Typography>
      </div>
    </div>
  );
};

export default NoDataComponent;
